import React from 'react'
import { ArrowDownCircle } from '../../../../../svg/arrow_down_circle'

const TramiteRealizarMantenerMiTipoFondoActual = () => {
  return (
    <div className={`tw-py-12`}>
    <div className={`border brad-4 shadow tw-px-8 tw-px-18@lg tw-py-8 tw-py-18@lg tw-mb-8`}>
      <div className={`tw-px-0 tw-px-20@lg tw-mb-12`}>
        <h2 className={`center font-family-secondary c-turquoise-0 tw-f-24 tw-f-24@lg tw-mt-0 tw-mb-8 tw-px-0 tw-px-12@lg`}>
          ¿Qué trámite debo realizar para mantener mi tipo de fondo
          actual?
        </h2>

        <div className={`center font-family-primary c-black-0 tw-f-16 tw-f-16@lg tw-mb-4 tw-px-0 tw-px-12@lg`}>
          Si deseas mantenerte en tu tipo de fondo actual, debes acercarte
          a una de nuestras agencias para realizar el trámite. Si vives en
          el extranjero, puedes realizar el trámite a través de un
          apoderado***.
        </div>

        <div className={`center font-family-primary c-black-0 tw-f-16 tw-f-16@lg tw-mb-4`}>
          Ten a la mano los siguientes documentos:
        </div>

        <div className={`center`}>
          <ArrowDownCircle fill={'#45494E'} />
        </div>
      </div>

      <div className={`tw-px-0 tw-px-12@lg`}>
        <ul className={'bulletList-0 font-family-primary tw-f-16 tw-f-16@lg'}>
          <li>
            Un testimonio de la escritura pública que le otorga poder para
            realizar el trámite. Debe estar inscrito en Registros Públicos
            y puede ser presentado en original o copia legalizada.
          </li>
          <li>
            Una vigencia de poder con una antigüedad no mayor a 30 días
            calendario desde que fue emitida. Si cumple con el requisito
            de antigüedad, basta con presentar el original de la copia
            literal emitida por Registros Públicos.
          </li>
          <li>
            Copia legalizada de tu DNI, carné de extranjería o pasaporte.
          </li>
          <li>
            El apoderado deberá identificarse con su documento de
            identidad.
          </li>
        </ul>
      </div>
    </div>

    <div className={`font-family-primary tw-f-14 tw-f-14@lg`}>
      <p>
        (*) El cambio automático al Fondo 1 a los 60 años es obligatorio
        por normativa SBS.
      </p>
      <p>
        (**) El cambio automático al Fondo 0 a los 65 años es obligatorio
        por normativa SBS.
      </p>
      <p>
        (***) Los documentos emitidos en el exterior, deben estar
        legalizados por el Consulado Peruano en el extranjero y visados
        por el Ministerio de Relaciones Exteriores en el Perú. Sin
        embargo, en caso el país emisor utilice el sistema de la
        certificación a través de la Apostilla, bastará que los documentos
        cuenten con dicha certificación. En caso la documentación sea
        emitida en un idioma distinto al español deberá ser traducida por
        un Traductor Público Juramentado del Perú, de acuerdo con lo
        establecido en el Reglamento de Traductores Públicos Juramentados
        (TPJ)
      </p>
    </div>
  </div>
  )
};

export default TramiteRealizarMantenerMiTipoFondoActual;
